import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
    },
    form: {
      padding: '15px',
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
    },
    buttons: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: '5px',
      marginBottom: theme.spacing(2),
    },
    avatar: {
      width: theme.spacing(14),
      height: theme.spacing(14),
      marginBottom: theme.spacing(2),
    },
    tableInfoHeader: {
      borderBottom: 'none',
    },
    tableInfo: {
      textAlign: 'right',
      borderBottom: 'none',
      color: theme.palette.text.secondary,
    },
    divider: {
      borderBottom: theme.spacing(1),
      width: '100%',
      marginBottom: theme.spacing(1),
    },
    story: {
      textAlign: 'left',
      marginBottom: theme.spacing(1),
    },
    link: {
      color: theme.palette.primary.main,
    },
    buttonsContainer: {
      display: 'flex',
      flexDirection: 'row-reverse',
      flexWrap: 'wrap',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    headerLabel: {
      fontWeight: 'bolder',
    },
    headerAge: {
      marginTop: theme.spacing(1),
    },
    cancelButton: {
      background: theme.palette.warning.dark,
    },
    accountsList: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      columnGap: theme.spacing(1),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  })
);
